export const translations = {
  ko: {
    // Header
    navigation: {
      about: 'About',
      works: 'Works',
      contact: 'Contact'
    },
    
    // Home Page
    home: {
      title: {
        lim: 'Lim',
        yun: 'yun',
        mook: "mook's",
        studio: 'Studio'
      }
    },
    
    // About Page
    about: {
      title: 'About',
      name: 'Lim yunmook',
      education: '학력',
      soloExhibitions: '개인전',
      groupExhibitions: '그룹전',
      awards: '선정',
      biography: `한 신문기자의 칼럼을 읽었다. 그 내용은,중동지역을 여행하던 중 문득 젊은 시절에 감영 깊게 읽은 한 소설이 떠올라 어느 상점에 들러 양탄자를 구매한 일에 대한 감상이었다. 그는 구매한 양탄자를 집으로 가져와바닥에 두는 대신 벽에 걸어 장식했다. 작업을 하면서 한동안 나는 어떤 그림을 그려야 할지 몰라 어려움을 겪었다. 어떤 그림은 쉽게 그려지기도했지만, 어떤 그림은 그렇지 않았다.버려지는 캔버스 천과 물감을 보며 원인이 무엇인지 파악하려고 애썼지만, 그저 막막할 뿐이었다.그러던 중 최근 자신을 깊이 들여다볼 기회가 있었다. 몇 가지 크고 작은 일들이 계기가 되어 상황을 그렇게 만들었다. 무심코 지나친 과거의 기억을 되짚어보고,사진첩을 훑으며 이전과는 다른관점으로,마음에 와닿 는 이미지를 선별해보았다.기자에게 감명을 준 소설도 읽어보았다. 소설에서 양탄자는 주인공이 어느 나이 든 시인에게 인생이 무엇이냐고 물었을 때 대답 대신 받은 선물이었다. 주인공은 여러 인생의 굴레를 경험한 후에 양탄자의 의미를 깨닫는다. 양탄자는 인생의 무목적성을 긍정한다. 직조공이 양탄자를 짜면서 자신의 심미감을 충족시키려는 목적 외 다른 목적을 갖지 않았듯이, 살아가면서 마주하게 되는 온갖 일들에 하나하나 집착하기보다, 나름의 무늬가 완성되어 가고 있음을 인정하면 된다는 것이다. 소설의 내용을 되뇌어 보며, 마음이 한결 편해짐을 느꼈다. 직조공이 양탄자를 짜듯이, 기자가 그것을 바닥에두지 않고 벽에 장식했듯이 나도 캔버스 프레임 없이 천을 벽에 고정하고, 양탄자의 날실을 연상하며 기름기없는 짧은 붓 터치로 천의 표면을 더듬었다. 이러한 작업 방식이 자연스럽게 느껴졌다. 서걱거리는 붓질의느낌에 집중하다 보니 어느새 그림은 나름의 무늬를 띄기 시작했다.`,
      educationItems: [
        { year: '2021', content: '단국대학교 일반대학원 회화과 졸업' },
        { year: '2018', content: '단국대학교 예술대학 서양화과 졸업' }
      ],
      soloExhibitionItems: [
        { year: '2024', content: '중요한 것은 마지막에 쓰여있다, 갤러리인, 서울' },
        { year: '2023', content: '양탄자 무늬, 청주미술창작스튜디오, 청주' },
        { year: '2019', content: 'Curtaincall, 갤러리 그리다, 서울' },
        { year: '2018', content: '시간의 흐름 속에서, 대안공간 눈, 수원' }
      ],
      groupExhibitionItems: [
        { 
          year: '2025', 
          content: '느슨한 유역, 충북갤러리, 서울<br/>사건의 무대, 대전시립미술관, 대전<br/>인상화 - 작가의 시선, 에브리아트, 서울<br/>느린 여름, 갤러리 아울, 후쿠오카<br/>교차된 시대의 흔적, 뮤지엄호두, 천안' 
        },
        { 
          year: '2024', 
          content: '의미를 갖는 순간, 에브리아트, 서울<br/>무늬를 삼킨 문, 윤진약국(소현문 주관), 용인' 
        },
        { 
          year: '2023', 
          content: '페리지 윈터쇼, 페리지갤러리, 서울<br/>회화 유니버스, 예술의전당 한가람디자인미술관, 서울' 
        },
        { 
          year: '2022', 
          content: '가위가위바위바위보보, 오픈스페이스배, 부산<br/>거의 정보가 없는 전시, 부산현대미술관, 부산<br/>일상이라는 몸, 쉐마미술관, 청주' 
        },
        { 
          year: '2021', 
          content: '머리 위 파도 가슴 밑 구름, 이목화랑 서울<br/>P는 그림을 걸었다, d/p, 서울' 
        },
        { 
          year: '2020', 
          content: '사각의 사각, 예술공간 의식주, 서울' 
        }
      ],
      awardItems: [
        { year: '2023', content: '청주미술창작스튜디오17기 입주작가' },
        { year: '2021', content: '온라인 미디어 지원 사업 선정,충북문화재단' },
        { year: '2020', content: '아트체인지업 지원 사업 선정,한국문화예술위원회' }
      ]
    },
    
    // Contact Page
    contact: {
      title: 'Contact',
      name: 'Lim yunmook',
      description: {
        line1: '전시 또는 작품과 관련 문의는',
        line2: '아래 연락처를 통해 연락 부탁드립니다.'
      }
    },
    
    // Footer
    footer: {
      copyright: 'Copyright 2025, Limyunmook All pictures cannot be copied without permission.'
    }
  },
  
  en: {
    // Header
    navigation: {
      about: 'About',
      works: 'Works',
      contact: 'Contact'
    },
    
    // Home Page
    home: {
      title: {
        lim: 'Lim',
        yun: 'yun',
        mook: "mook's",
        studio: 'Studio'
      }
    },
    
    // About Page
    about: {
      title: 'About',
      name: 'Lim yunmook',
      education: 'Education',
      soloExhibitions: 'Solo Exhibitions',
      groupExhibitions: 'Group Exhibitions',
      awards: 'Awards & Grants',
      biography: `I read a journalist's column about purchasing a carpet from a shop during his travels in the Middle East, reminded of a novel he had deeply read in his youth. Instead of placing the carpet on the floor, he hung it on the wall as decoration. For a while during my work, I struggled not knowing what kind of painting to create. Some paintings came easily, while others did not. Looking at the discarded canvas and paint, I tried to understand the cause, but I was simply at a loss. Recently, I had an opportunity to look deeply into myself. Several big and small events created this situation. I revisited past memories I had carelessly passed by, browsed through photo albums, and selected images that touched my heart from a different perspective than before. I also read the novel that impressed the journalist. In the novel, the carpet was a gift the protagonist received instead of an answer when he asked an elderly poet what life was. The protagonist realizes the meaning of the carpet after experiencing various trials of life. The carpet affirms life's purposelessness. Just as a weaver weaves a carpet with no purpose other than satisfying their aesthetic sense, rather than obsessing over each situation we encounter in life, we should acknowledge that our own pattern is being completed. Reflecting on the novel's content, I felt my heart become more at ease. Like a weaver weaving a carpet, like the journalist decorating it on the wall instead of placing it on the floor, I too fixed canvas without frames to the wall and, recalling the warp threads of carpets, explored the surface of the canvas with short, oil-free brush strokes. This working method felt natural. Focusing on the scratching feeling of brushstrokes, the painting gradually began to show its own pattern.`,
      educationItems: [
        { year: '2021', content: 'MFA in Painting, Graduate School of Dankook University' },
        { year: '2018', content: 'BFA in Western Painting, College of Arts, Dankook University' }
      ],
      soloExhibitionItems: [
        { year: '2024', content: 'The Important Thing is Written at the End, Gallery IN, Seoul' },
        { year: '2023', content: 'Carpet Pattern, Cheongju Art Studio, Cheongju' },
        { year: '2019', content: 'Curtain Call, Gallery Grida, Seoul' },
        { year: '2018', content: 'In the Flow of Time, Alternative Space NOON, Suwon' }
      ],
      groupExhibitionItems: [
        { 
          year: '2025', 
          content: 'Loose Basin, Chungbuk Gallery, Seoul<br/>Stage Where It All Unfolded, Daejeon Museum of Art, Daejeon<br/>Impressions - Artist\'s Perspective, Every Art, Seoul<br/>Slow Shower, Gallery Owl, Fukuoka<br/>Traces of Intersected Eras, Museum Hodu, Cheonan' 
        },
        { 
          year: '2024', 
          content: 'The Moment of Meaning, EveryArt, Seoul<br/>The Door That Swallowed Patterns, Yunjin Pharmacy (curated by So Hyun Moon), Yongin' 
        },
        { 
          year: '2023', 
          content: 'Perigee Winter Show, Perigee Gallery, Seoul<br/>Painting Universe, Hangaram Design Museum, Seoul Arts Center, Seoul' 
        },
        { 
          year: '2022', 
          content: 'Rock Paper Scissors Scissors Rock Rock, Open Space BAE, Busan<br/>Exhibition with Almost No Information, Busan Museum of Contemporary Art, Busan<br/>Daily Life as a Body, Schema Museum, Cheongju' 
        },
        { 
          year: '2021', 
          content: 'Waves Above Head, Clouds Under Heart, Lee Mok Gallery, Seoul<br/>P Hung the Painting, d/p, Seoul' 
        },
        { 
          year: '2020', 
          content: 'Rectangle of Rectangle, Art Space UiSikJu, Seoul' 
        }
      ],
      awardItems: [
        { year: '2023', content: 'Selected as 17th Cheongju Art Studio Resident Artist' },
        { year: '2021', content: 'Selected for Online Media Support Project, Chungbuk Arts Foundation' },
        { year: '2020', content: 'Selected for Art Change Up Support Project, Korea Arts Council' }
      ]
    },
    
    // Contact Page
    contact: {
      title: 'Contact',
      name: 'Lim yunmook',
      description: {
        line1: 'For inquiries about exhibitions or artworks,',
        line2: 'please contact us through the information below.'
      }
    },
    
    // Footer
    footer: {
      copyright: 'Copyright 2025, Limyunmook All pictures cannot be copied without permission.'
    }
  }
};

// Helper function to get translated text
export const t = (key, language) => {
  const keys = key.split('.');
  let translation = translations[language];
  
  for (const k of keys) {
    translation = translation?.[k];
  }
  
  return translation || key;
};